import { FeatureFragment } from '../../Drawer.generated'
import { DetailItem } from '../DetailsList'
import { MultiValueItem, MultiValueList } from '../DetailsList/Multi'

const compareFacilities = (a: FeatureFragment, b: FeatureFragment): number =>
  a.name.localeCompare(b.name)

interface FacilitiesListProps {
  heading: string
  facilities: FeatureFragment[]
}

const FacilitiesDetail = ({
  heading,
  facilities,
}: FacilitiesListProps): JSX.Element | null => (
  <DetailItem heading={heading}>
    {facilities.length > 0 && (
      <MultiValueList>
        {facilities.sort(compareFacilities).map(({ id, name }) => (
          <MultiValueItem key={id}>{name}</MultiValueItem>
        ))}
      </MultiValueList>
    )}
  </DetailItem>
)

export default FacilitiesDetail
